import { css } from 'styled-components';

import { url } from '@/utils/styles';

import transparency from '@/images/transparency-light.svg';

const LightTheme = css`
  --color-ai: rgb(39, 219, 22);
  --color-ai-gradient-start: rgb(39, 219, 22);
  --color-ai-gradient-end: rgb(18, 198, 2);
  --color-ai-background: rgb(240, 255, 239);
  --color-ai-translucent: rgba(33, 242, 13, 0.07);
  --color-background-dark: rgb(245, 245, 245);
  --color-background-dark-translucent: rgba(245, 245, 245, 0.9);
  --color-background-dark-transparent: rgba(245, 245, 245, 0.7);
  --color-background-hover: rgb(250, 250, 250);
  --color-background-light: rgb(255, 255, 255);
  --color-background-light-translucent: rgba(255, 255, 255, 0.9);
  --color-border-active: rgb(0, 83, 81);
  --color-champaign: rgb(241, 221, 207);
  --color-clover: rgb(0, 155, 138);
  --color-clover-active: rgb(0, 143, 127);
  --color-clover-hover: rgb(50, 175, 161);
  --color-clover-overlay: rgba(0, 83, 81, 0.8);
  --color-gray-01: rgba(0, 0, 0, 0.01);
  --color-gray-02: rgba(0, 0, 0, 0.02);
  --color-gray-03: rgba(0, 0, 0, 0.03);
  --color-gray-04: rgba(0, 0, 0, 0.04);
  --color-gray-05: rgba(0, 0, 0, 0.05);
  --color-gray-07: rgba(0, 0, 0, 0.07);
  --color-gray-10: rgba(0, 0, 0, 0.10);
  --color-gray-20: rgba(0, 0, 0, 0.20);
  --color-gray-30: rgba(0, 0, 0, 0.30);
  --color-gray-40: rgba(0, 0, 0, 0.40);
  --color-gray-50: rgba(0, 0, 0, 0.50);
  --color-gray-60: rgba(0, 0, 0, 0.60);
  --color-gray-70: rgba(0, 0, 0, 0.70);
  --color-gray-80: rgba(0, 0, 0, 0.80);
  --color-jade: rgb(222, 246, 238);
  --color-jade-translucent: rgba(35, 195, 140, 0.15);
  --color-mint: rgb(125, 218, 186);
  --color-mint-background: rgb(221, 240, 233);
  --color-mint-active: rgb(98, 188, 157);
  --color-mint-hover: rgb(132, 230, 196);
  --color-mint-translucent: rgba(125, 218, 186, 0.2);
  --color-overlay: rgba(255, 255, 255, 0.5);
  --color-pine: rgb(0, 83, 81);
  --color-pine-active: rgb(17, 85, 82);
  --color-pine-hover: rgb(15, 108, 105);
  --color-rouge: rgb(178, 54, 101);
  --color-rouge-active: rgb(164, 50, 93);
  --color-rouge-background: rgb(244, 225, 232);
  --color-rouge-hover: rgb(189, 81, 123);
  --color-sand: rgb(255, 242, 235);
  --color-shadow: rgba(0, 0, 0, 0.14);
  --color-shadow-soft: rgba(0, 0, 0, 0.07);
  --color-tango: rgb(228, 113, 122);
  --color-text: rgba(0, 0, 0, 0.8);
  --color-text-active: rgb(255, 255, 255);
  --color-tooltip: rgba(0, 0, 0, 0.8);
  --font-delight: "Delight", sans-serif;
  --font-vela-sans: "VelaSans", sans-serif;
  --font-weight-bold: 700;
  --font-weight-light: 300;
  --font-weight-medium: 500;
  --font-weight-regular: 400;
  --font-weight-semi-bold: 600;
  --icon-transparency: ${url(transparency)};
`;

export default LightTheme;
